import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from '@/store';
import { GlobalStyles } from '@/globalStyles';
import { QueryClientProvider } from '@/app/QueryClientProvider';
import { MessageProvider } from '@/app/MessageProvider';
import '@/app/localization';
import { ThemeProvider } from '@/app/ThemeProvider';
import { ErrorBoundary } from '@/app/ErrorBoundary';
import { BrowserRouter } from 'react-router';
import { AxiosInterceptor } from '@/api';

const root = createRoot(document.getElementById('root'));

root.render(
  <QueryClientProvider>
    <Provider store={store}>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true
        }}
      >
        <ThemeProvider>
          <MessageProvider>
            <ErrorBoundary>
              <AxiosInterceptor>
                <App />
              </AxiosInterceptor>
            </ErrorBoundary>
            <GlobalStyles />
          </MessageProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </QueryClientProvider>
);
